import {precacheAndRoute as workbox_precaching_precacheAndRoute} from 'c:/laragon/www/fixmaster/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








self.addEventListener('message', (event) => {
  if (event.data && event.data.type === 'SKIP_WAITING') {
    self.skipWaiting();
  }
});




/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "fixmaster.a4ea37dc2291d06a273b.css",
    "revision": null
  },
  {
    "url": "fixmaster.js",
    "revision": "00f6ddc47fbe2a99cb982fcc478c4053"
  },
  {
    "url": "fixmaster.js.LICENSE.txt",
    "revision": "de6cf8813fe070cde33f8f7bf7424524"
  },
  {
    "url": "index.html",
    "revision": "fe9b7eb253de9c909dbbeaa7e0a8788c"
  }
], {});








